import { render, staticRenderFns } from "./SimpleRow.vue?vue&type=template&id=2010c446&scoped=true"
import script from "./SimpleRow.vue?vue&type=script&lang=js"
export * from "./SimpleRow.vue?vue&type=script&lang=js"
import style0 from "./SimpleRow.vue?vue&type=style&index=0&id=2010c446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2010c446",
  null
  
)

export default component.exports